// extracted by mini-css-extract-plugin
export var createdDate = "_lm-1";
export var divider = "_lm-2";
export var headerDivider = "_lm-3";
export var messagesCard = "_lm-0";
export var messagesContainer = "_lm-7";
export var messagesContainerWrapper = "_lm-4";
export var pointerCapturingButtonBoxes = "_lm-a";
export var showLeftPanelButton = "_lm-9";
export var showMoreButton = "_lm-c";
export var showMoreButtonContainer = "_lm-b";
export var summaryTitle = "_lm-6";
export var systemMessageCardWrapper = "_lm-d";
export var topButtons = "_lm-8";
export var withPadding = "_lm-5";